import type * as React from "react"
import { cn } from "../lib/utils"

interface PageHeaderProps {
  title: string
  description?: string
  children?: React.ReactNode
  className?: string
  testId?: string
}

export function PageHeader({ title, description, children, className, testId }: PageHeaderProps) {
  return (
    <div className={cn("mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between", className)} data-testid={testId}>
      <div className="space-y-1">
        <h1 className="text-2xl font-bold tracking-tight sm:text-3xl" data-testid={testId ? `${testId}-title` : undefined}>{title}</h1>
        {description && <p className="text-muted-foreground" data-testid={testId ? `${testId}-description` : undefined}>{description}</p>}
      </div>
      {children && <div className="flex items-center gap-3" data-testid={testId ? `${testId}-actions` : undefined}>{children}</div>}
    </div>
  )
}
